import axios from 'axios'
import urls from '../../util/urls'

const state = {
  listaDeContasPagarAtrasadas: []
}

const mutations = {
  atualizarListaDeContasPagarAtrasadas(state, payload) {
    state.listaDeContasPagarAtrasadas = payload;
  },

  limparContasPagar(state) {
    state.listaDeContasPagarAtrasadas = [];
  }
}

const actions = {
  recuperarContasPagarAtrasadas(context) {
    return axios.get(urls.DASHBOARD_RECUPERAR_CONTAS_PAGAR_ATRASADAS)
    .then((response) => {
      switch (response.data.status) {
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('recuperarContasPagarAtrasadas');
            }
          }).catch(error => {
            throw error;
          });
        default:
          return context.commit('atualizarListaDeContasPagarAtrasadas', response.data.lista);
      }
    }).catch((error) => {
      throw error;
    });
  }
}

export default {
  state,
  mutations,
  actions
}